import { render } from "./UiPageHeader.vue?vue&type=template&id=54a8f628&scoped=true"
import script from "./UiPageHeader.vue?vue&type=script&lang=js"
export * from "./UiPageHeader.vue?vue&type=script&lang=js"

import "./UiPageHeader.vue?vue&type=style&index=0&id=54a8f628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a8f628"]])

export default __exports__